module.exports = __webpack_public_path__ + "static/1-b7deebeb7c5ec4a4e7153a42ece9640d.jpg";